export const ADD_DEVICE = "ADD_DEVICE";
export const FETCH_DEVICES = "FETCH_DEVICES";
export const ASSIGN_DEVICE = "ASSIGN_DEVICE";
export const UNASSIGN_DEVICE = "UNASSIGN_DEVICE";
export const UPDATE_DEVICE_STATUS = "UPDATE_DEVICE_STATUS";
export const GENERATE_DEVICE_PIN = "GENERATE_DEVICE_PIN";
export const SET_DEVICE_PAIRED_STATUS = "SET_DEVICE_PAIRED_STATUS"